(() => {
  if (typeof customElements === 'undefined' || customElements.get('ombre-faq-search')) return;

  class OmbreFaqSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-ombre-faq-search]');
      this.status = this.querySelector('[data-ombre-faq-status]');
      this.groups = Array.from(this.querySelectorAll('[data-ombre-faq-group]'));
      this.handleInput = this.filter.bind(this);
      this.input?.addEventListener('input', this.handleInput);
      this.filter();
    }

    disconnectedCallback() {
      this.input?.removeEventListener('input', this.handleInput);
    }

    filter() {
      const query = (this.input?.value || '').trim().toLowerCase();
      const terms = query.split(/\s+/).filter(Boolean);
      let visibleCount = 0;

      this.groups.forEach((group) => {
        const items = Array.from(group.querySelectorAll('[data-ombre-faq-item]'));
        const category = group.querySelector('h2')?.textContent || '';
        let visibleInGroup = 0;

        items.forEach((item) => {
          const searchableText = `${category} ${item.textContent || ''}`.toLowerCase();
          const isMatch = terms.every((term) => searchableText.includes(term));
          item.hidden = !isMatch;
          if (isMatch) {
            visibleCount += 1;
            visibleInGroup += 1;
          }
        });

        group.hidden = visibleInGroup === 0;
      });

      if (!this.status) return;
      if (!query) {
        this.status.textContent = `${visibleCount} ${visibleCount === 1 ? 'answer' : 'answers'}`;
      } else {
        this.status.textContent = `${visibleCount} ${visibleCount === 1 ? 'answer found' : 'answers found'}`;
      }
    }
  }

  customElements.define('ombre-faq-search', OmbreFaqSearch);
})();
